<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-5 gray--text mr-5">03</div>
      <div class="heading-5 font-weight-medium">
        Approve Transaction
      </div>
    </div>
    <p class="text-5 mt-3">
      This action will approve this transaction. A separate Transaction will be
      performed to submit the approval.
    </p>
    <div class="mt-3">
      <div class="text-5 darkgray--text">Transaction nonce:</div>
      <div class="text-4">0</div>
    </div>
    <div class="mt-3" v-if="ableToExecuteTx">
      <p class="text-5 primary--text">
        Approving this transaction executes it right away. If you want approve
        but execute the transaction manually later, uncheck the checkbox below.
      </p>
      <v-checkbox
        v-model="executeTxCheck"
        hide-details
        label="Execute Transaction"
        class="mt-0"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    ableToExecuteTx() {
      return true;
    },
  },
  data: () => ({
    executeTxCheck: true,
  }),
};
</script>
